import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
declare let ga: Function;

@Injectable()
export class GoogleAnalyticsEventsService {

  public emitEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null,
  ) {

      if (environment.production) {
        ga('send', 'event', {
          eventCategory: eventCategory,
          eventLabel: eventLabel,
          eventAction: eventAction,
          eventValue: Math.round(eventValue),  // ga only accepts int
        });
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/Services/google-analytics.ts